import { motion } from "framer-motion";
import { TESTIMONIALS } from "@/data/site";

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 md:py-32 border-t border-slate-100 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="mb-16 md:mb-20 grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
          <div className="md:col-span-7">
            <div className="text-xs uppercase tracking-[0.24em] text-blue-600 font-semibold">/ Testimonials</div>
            <h2 className="mt-4 font-display text-4xl md:text-6xl font-light tracking-tight text-slate-900 leading-[1.02]">
              Growth teams that <span className="font-serif-editorial italic">stayed</span>.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: (i % 2) * 0.1, duration: 0.8 }}
              className="relative bg-[#fafafa] border border-slate-100 rounded-3xl p-8 md:p-10 flex flex-col justify-between"
              data-testid={`testimonial-${i}`}
            >
              <div className="absolute top-6 right-8 font-serif-editorial text-7xl text-slate-200 leading-none select-none">"</div>
              <blockquote className="text-lg md:text-xl text-slate-800 leading-relaxed font-light">
                {t.quote}
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-slate-200/70 flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-slate-900 text-white flex items-center justify-center font-display text-sm font-medium">
                  {t.name.split(" ").map((s) => s[0]).slice(0, 2).join("")}
                </div>
                <div>
                  <div className="font-medium text-slate-900 text-sm">{t.name}</div>
                  <div className="text-xs text-slate-500 mt-0.5">{t.role} · {t.city}</div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
